import * as Sentry from "@sentry/vue";
import type { App } from "vue";

export function initSentry(app: App) {
    if (!import.meta.env.PROD) {
        return;
    }
    Sentry.init({
        app,
        dsn: "https://5d989def3ec7a73d1ceb9341a98d1bcf@o4511645794041856.ingest.us.sentry.io/4511646450057216",
        sendDefaultPii: true,
        enableLogs: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Sentry.replayIntegration({ // 
            //     maskAllText: true,
            //     blockAllMedia: true,
            // }),
            Sentry.consoleLoggingIntegration({
                levels: ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
            }),
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
        release: import.meta.env.PUBLIC_SOURCE_COMMIT,
    });
}
